import { createMsg } from 'action-typed';

import { Messages, NavigationCompleteData, NavigationEvents } from './types';

export const NavigationMessage = createMsg<Messages>();

export function navigationComplete(data: NavigationCompleteData) {
    return NavigationMessage(NavigationEvents.NAVIGATION_COMPLETE, data);
}
